export const ERROR_MODIFY_APPROVED_CALENDAR = 150
